// Reuse locale settings on animation ticks; no product values are cached here.
const wholeCurrency = new Intl.NumberFormat('sv-SE', {
  style: 'currency', currency: 'SEK', minimumFractionDigits: 0, maximumFractionDigits: 2,
});
const centsCurrency = new Intl.NumberFormat('sv-SE', {
  style: 'currency', currency: 'SEK', minimumFractionDigits: 2, maximumFractionDigits: 2,
});
export const formatCurrency = (amount) => {
  if (amount == null) return '-';
  const num = typeof amount === 'string' ? parseFloat(amount) : amount;
  if (isNaN(num)) return '-';
  return (Math.round(num * 100) % 100 === 0 ? wholeCurrency : centsCurrency).format(num);
};
